import { MULTILINGUAL } from '@/constants';
import { DEFAULT_VOICE_AGENTS } from '@/state/presenters';
import { IVoice, Providers } from '@d-id/types';

export const voiceOptionsForMultiLingual = (languageToVoicesMap: Record<string, IVoice[]>) => {
    const trimmedLanguage = DEFAULT_VOICE_AGENTS.language.split(' ')[0];
    return [
        ...languageToVoicesMap[DEFAULT_VOICE_AGENTS.language]
            .filter(voice => ![Providers.Microsoft, Providers.AzureOpenAi].includes(voice.provider) || voice.id?.includes(MULTILINGUAL))
            .map(voice => ({ ...voice, language: MULTILINGUAL })),
        ...languageToVoicesMap[trimmedLanguage]
            .filter(voice => ![Providers.Microsoft, Providers.AzureOpenAi].includes(voice.provider))
            .map(voice => ({ ...voice, language: MULTILINGUAL })),
    ];
};
